import { MultiSelect as MultiSelects } from 'primereact/multiselect';  

const MultiSelectz = ({...rest}) => {

    return (
        <MultiSelects {...rest} />
    )

};

export default MultiSelectz;